export default __webpack_public_path__ + "bbc1340edbf2f4b66ac065fda43cb407.wav";